import { features, FeatureNameType } from '@/utils/features'

export default (name: FeatureNameType, active = true): boolean => {
    const feature = features.find(item => item.name === name)
    return active && feature?.active === 'true'
}
